import { getCurrentPeriod } from "../../../common/util/period";
import type { GroupLeader, GroupLeaderNode } from "../../../services/ActionReports/ActionReportAPI.types";
import type { GroupSopRecord } from "./GroupSopReport";
import { SOP_TABS } from "./sopTabs";
import type { SopMonthData } from "./OverviewCard/OverviewCard";
export const SOP_PRODUCT_IMAGES = [
  "https://cdn.contentstack.io/v3/assets/bltf569fd53b744e739/blt29608f1d1e8ce6ca/6a39f09b7569fe76ef166bab/100016J_0008_1_PDP.jpg",
  "https://cdn.contentstack.io/v3/assets/bltf569fd53b744e739/bltaefa445b142b0408/6a432df958fbd747eec3712f/330121J_5490_1_PDP.jpg",
  "https://cdn.contentstack.io/v3/assets/bltf569fd53b744e739/blt6885ca06c6317791/6a9fcc71b746309691b45ff0/317411DAM_5866_1_PDP.jpg",
  "https://cdn.contentstack.io/v3/assets/bltf569fd53b744e739/blt057ec10826b7cefc/6a3c87e10bf9094a9a0045ff/267521J_9008_1_PDP.jpg",
  "https://cdn.contentstack.io/v3/assets/bltf569fd53b744e739/bltf276add6b95214c2/6a9e69d20dada1b73cfbbecb/115259DAM_5182_1_PDP.png",
  "https://cdn.contentstack.io/v3/assets/bltf569fd53b744e739/bltc3311f9f0fda621f/6a9fc86c638a888078e13bef/299923DDD_5519_1_PDP.jpg",
  "https://www.amway.com/medias/125915-en-US-690px-01?context=bWFzdGVyfGltYWdlc3wxNjc0MTJ8aW1hZ2UvcG5nfHN5cy1tYXN0ZXIvaW1hZ2VzL2gxZS9oNmYvOTU3Mzc3MjQ2MDA2Mi8xMjU5MTUtZW4tVVMtNjkwcHgtMDF8NGQzYmM5MjYyNDY2YmI5OWYzODk3MmI3ZTM5NDJjODBjN2YyNTNhNjE3MGQ0MDg0NjhhMjI1NDUyMWIxZGNlYg",
];

export const SOP_PRODUCT_NAMES = [
  "Nutrilite-Q Plus™",
  "Nutrilite Begin™ Daily GI Primer",
  "XS™ Muscle Multiplier - Pineapple",
  "Artistry Studio™ Clean Start Micellar Makeup Remover + Cleanser",
  "Nutrilite™ Organics Plant Protein Powder – Unflavored",
  "Herblast™ Tea - Lemon",
  "g&h™ Refresh Exfoliating Body Wash",
];
export const GROUP_SOP_MOCK_LEADERS: GroupLeader[] = [
  { aff: "100", abo: "1234567001", name: "Ava Thompson", entryDate: "2015-01-01", pinLevel: 370 },
  { aff: "100", abo: "1234567002", name: "Noah Foster", entryDate: "2016-01-01", pinLevel: 330 },
];

export const GROUP_SOP_MOCK_LEADER_TREE: GroupLeaderNode[] = GROUP_SOP_MOCK_LEADERS.map((leader) => ({
  ...leader,
  children: [],
}));

// Alternate mock downlines between the two leaders by ABO suffix; the real report gets this mapping from its API.
export const getGroupSopMockLeaderAbo = (abo: string): string =>
  Number(abo.slice(-1)) % 2 === 0 ? GROUP_SOP_MOCK_LEADERS[0].abo : GROUP_SOP_MOCK_LEADERS[1].abo;
export const GROUP_SOP_MOCK_DATA: Record<SOP_TABS, GroupSopRecord[]> = {
  [SOP_TABS.ORDER_RENEWAL]: [
    {
      aff: "100",
      abo: "1234567890",
      aboNumber: "1234567890",
      aboName: "Lisa Smith",
      phoneNumber: "+12025550101",
      businessNature: "3",
      businessNatureTag: "customer",
      level: 2,
      personalPV: "--",
      customerPV: 10000,
      currentPPV: "--",
      currentSopPv: 10000,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[1]],
      sopProductCount: 2,
      upForRenewal: true,
    },
    {
      aff: "100",
      abo: "1234567891",
      aboNumber: "1234567891",
      aboName: "Matt Johnson",
      phoneNumber: "+12025550102",
      businessNatureTag: "abo",
      level: 5,
      personalPV: 0,
      customerPV: 0,
      currentPPV: 0,
      currentSopPv: 0,
      expectedSopPv: 30000,
      productImages: [
        SOP_PRODUCT_IMAGES[2],
        SOP_PRODUCT_IMAGES[3],
        SOP_PRODUCT_IMAGES[4],
        SOP_PRODUCT_IMAGES[5],
        SOP_PRODUCT_IMAGES[6],
        SOP_PRODUCT_IMAGES[0],
      ],
      sopProductCount: 6,
      upForRenewal: true,
    },
    {
      aff: "100",
      abo: "1234567892",
      aboNumber: "1234567892",
      aboName: "Ann Wilson",
      phoneNumber: "+12025550103",
      businessNatureTag: "abo",
      level: 4,
      personalPV: 1000,
      customerPV: 250,
      currentPPV: 1000,
      currentSopPv: 0,
      expectedSopPv: 10000,
      productImages: [SOP_PRODUCT_IMAGES[6], SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[1]],
      sopProductCount: 3,
      upForRenewal: false,
    },
  ],
  [SOP_TABS.PV_THIS_MONTH]: [
    {
      aff: "100",
      abo: "1234567893",
      aboNumber: "1234567893",
      aboName: "Chris Miller",
      phoneNumber: "+12025550104",
      businessNatureTag: "abo",
      level: 3,
      personalPV: 2400,
      customerPV: 350,
      currentPPV: 2400,
      currentSopPv: 7500,
      expectedSopPv: 10000,
      productImages: [SOP_PRODUCT_IMAGES[1], SOP_PRODUCT_IMAGES[2], SOP_PRODUCT_IMAGES[3], SOP_PRODUCT_IMAGES[4]],
      sopProductCount: 4,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567894",
      aboNumber: "1234567894",
      aboName: "Dana Lee",
      phoneNumber: "+12025550105",
      level: 6,
      personalPV: 1200,
      customerPV: 0,
      currentPPV: 1200,
      currentSopPv: 900,
      expectedSopPv: 1200,
      productImages: [SOP_PRODUCT_IMAGES[4], SOP_PRODUCT_IMAGES[5], SOP_PRODUCT_IMAGES[6]],
      sopProductCount: 3,
      upForRenewal: true,
    },
    {
      aff: "100",
      abo: "1234567895",
      aboNumber: "1234567895",
      aboName: "Morgan Taylor",
      phoneNumber: "+12025550106",
      businessNature: "3",
      level: 2,
      personalPV: "--",
      customerPV: 650,
      currentPPV: "--",
      currentSopPv: 650,
      expectedSopPv: 1000,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[6]],
      sopProductCount: 2,
      upForRenewal: false,
    },
  ],
  [SOP_TABS.NO_PV_THIS_MONTH]: [
    {
      aff: "100",
      abo: "1234567896",
      aboNumber: "1234567896",
      aboName: "Alex Morgan",
      phoneNumber: "+12025550107",
      businessNatureTag: "abo",
      level: 3,
      personalPV: 2400,
      customerPV: 0,
      currentPPV: 2400,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[1]],
      sopProductCount: 2,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567897",
      aboNumber: "1234567897",
      aboName: "Jamie Chen",
      phoneNumber: "+12025550108",
      businessNatureTag: "abo",
      level: 4,
      personalPV: 1800,
      customerPV: 250,
      currentPPV: 1800,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[2], SOP_PRODUCT_IMAGES[3], SOP_PRODUCT_IMAGES[4]],
      sopProductCount: 3,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567898",
      aboNumber: "1234567898",
      aboName: "Riley Brooks",
      phoneNumber: "+12025550109",
      businessNatureTag: "abo",
      level: 5,
      personalPV: 1200,
      customerPV: 0,
      currentPPV: 1200,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[5]],
      sopProductCount: 1,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567899",
      aboNumber: "1234567899",
      aboName: "Taylor Kim",
      phoneNumber: "+12025550110",
      businessNatureTag: "abo",
      level: 6,
      personalPV: 900,
      customerPV: 150,
      currentPPV: 900,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [
        SOP_PRODUCT_IMAGES[6],
        SOP_PRODUCT_IMAGES[0],
        SOP_PRODUCT_IMAGES[2],
        SOP_PRODUCT_IMAGES[3],
        SOP_PRODUCT_IMAGES[4],
      ],
      sopProductCount: 5,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567900",
      aboNumber: "1234567900",
      aboName: "Casey Rivera",
      phoneNumber: "+12025550111",
      businessNature: "3",
      businessNatureTag: "customer",
      level: 2,
      personalPV: "--",
      customerPV: 800,
      currentPPV: "--",
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[1], SOP_PRODUCT_IMAGES[5]],
      sopProductCount: 2,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567901",
      aboNumber: "1234567901",
      aboName: "Jordan Patel",
      phoneNumber: "+12025550112",
      businessNatureTag: "abo",
      level: 2,
      personalPV: 700,
      customerPV: 0,
      currentPPV: 700,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[2]],
      sopProductCount: 2,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567902",
      aboNumber: "1234567902",
      aboName: "Avery Thompson",
      phoneNumber: "+12025550113",
      businessNatureTag: "abo",
      level: 3,
      personalPV: 500,
      customerPV: 200,
      currentPPV: 500,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[1], SOP_PRODUCT_IMAGES[3], SOP_PRODUCT_IMAGES[5]],
      sopProductCount: 3,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567903",
      aboNumber: "1234567903",
      aboName: "Morgan Ellis",
      phoneNumber: "+12025550114",
      businessNatureTag: "abo",
      level: 4,
      personalPV: 350,
      customerPV: 0,
      currentPPV: 350,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[4]],
      sopProductCount: 1,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567904",
      aboNumber: "1234567904",
      aboName: "Quinn Foster",
      phoneNumber: "+12025550115",
      businessNature: "3",
      businessNatureTag: "customer",
      level: 2,
      personalPV: "--",
      customerPV: 300,
      currentPPV: "--",
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[3]],
      sopProductCount: 2,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567905",
      aboNumber: "1234567905",
      aboName: "Skyler Reed",
      phoneNumber: "+12025550116",
      businessNatureTag: "abo",
      level: 5,
      personalPV: 225,
      customerPV: 0,
      currentPPV: 225,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[1], SOP_PRODUCT_IMAGES[2], SOP_PRODUCT_IMAGES[6]],
      sopProductCount: 3,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567906",
      aboNumber: "1234567906",
      aboName: "Drew Wallace",
      phoneNumber: "+12025550117",
      businessNatureTag: "abo",
      level: 6,
      personalPV: 150,
      customerPV: 75,
      currentPPV: 150,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[2], SOP_PRODUCT_IMAGES[4], SOP_PRODUCT_IMAGES[6]],
      sopProductCount: 4,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567907",
      aboNumber: "1234567907",
      aboName: "Robin Hayes",
      phoneNumber: "+12025550118",
      businessNatureTag: "abo",
      level: 2,
      personalPV: 100,
      customerPV: 0,
      currentPPV: 100,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[5], SOP_PRODUCT_IMAGES[6]],
      sopProductCount: 2,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567908",
      aboNumber: "1234567908",
      aboName: "Devon Price",
      phoneNumber: "+12025550119",
      businessNatureTag: "abo",
      level: 3,
      personalPV: 0,
      customerPV: 500,
      currentPPV: 0,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[1], SOP_PRODUCT_IMAGES[4]],
      sopProductCount: 2,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567909",
      aboNumber: "1234567909",
      aboName: "Samira Cole",
      phoneNumber: "+12025550120",
      businessNatureTag: "abo",
      level: 4,
      personalPV: 0,
      customerPV: 275,
      currentPPV: 0,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[0], SOP_PRODUCT_IMAGES[3], SOP_PRODUCT_IMAGES[5]],
      sopProductCount: 3,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567910",
      aboNumber: "1234567910",
      aboName: "Lee Bennett",
      phoneNumber: "+12025550121",
      businessNatureTag: "abo",
      level: 5,
      personalPV: 0,
      customerPV: 100,
      currentPPV: 0,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[2]],
      sopProductCount: 1,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567911",
      aboNumber: "1234567911",
      aboName: "Jessie Nguyen",
      phoneNumber: "+12025550122",
      businessNatureTag: "abo",
      level: 6,
      personalPV: 0,
      customerPV: 50,
      currentPPV: 0,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [
        SOP_PRODUCT_IMAGES[0],
        SOP_PRODUCT_IMAGES[1],
        SOP_PRODUCT_IMAGES[4],
        SOP_PRODUCT_IMAGES[5],
        SOP_PRODUCT_IMAGES[6],
      ],
      sopProductCount: 5,
      upForRenewal: false,
    },
    {
      aff: "100",
      abo: "1234567912",
      aboNumber: "1234567912",
      aboName: "Kai Sullivan",
      phoneNumber: "+12025550123",
      businessNatureTag: "abo",
      level: 2,
      personalPV: 0,
      customerPV: 0,
      currentPPV: 0,
      currentSopPv: 0,
      expectedSopPv: 0,
      productImages: [SOP_PRODUCT_IMAGES[2], SOP_PRODUCT_IMAGES[3]],
      sopProductCount: 2,
      upForRenewal: false,
    },
  ],
};

export const mockForcastedSop: SopMonthData[] = [
  {
    period: Number(getCurrentPeriod()),
    currentPV: "10,000",
    expectedPV: "12,000",
    ordersUpForRenewal: "2",
    downlinesOnSOPTotal: {
      value: "20",
      trend: {
        trend: "higher",
        difference: "2",
      },
    },
    downlinesOnSOPMonth: "3",
    downlinesNotOnSopThisMonth: "17",
    groupPercent: "70%",
  },
];

export const mockForcastedSopByLeader: Record<string, SopMonthData[]> = {
  "1234567001": [
    {
      period: Number(getCurrentPeriod()),
      currentPV: "6,500",
      expectedPV: "8,000",
      ordersUpForRenewal: "1",
      downlinesOnSOPTotal: { value: "10", trend: { trend: "higher", difference: "1" } },
      downlinesOnSOPMonth: "2",
      downlinesNotOnSopThisMonth: "8",
      groupPercent: "25%",
    },
  ],
  "1234567002": [
    {
      period: Number(getCurrentPeriod()),
      currentPV: "6,000",
      expectedPV: "4,000",
      ordersUpForRenewal: "1",
      downlinesOnSOPTotal: { value: "8", trend: { trend: "higher", difference: "1" } },
      downlinesOnSOPMonth: "1",
      downlinesNotOnSopThisMonth: "7",
      groupPercent: "25%",
    },
  ],
};
